import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, } from '@mui/material';
import './Dashboard.css';
import MyWorkflows from '../components/MyWorkflows';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { setViewMode } from '../redux/actions/actions';


const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userType = useSelector((state) => state.auth.userDetails?.user_type);
  const partnerCustomer = useSelector((state) => state.partner.partnerCustomer);

  useEffect(() => {
    // Navigate if userType is 2 or 3 AND partnerCustomer.customerId is missing/null/undefined
    if ((userType === 2 || userType === 3) && partnerCustomer.customerId) {
      localStorage.setItem("viewMode", "customer-view")
      dispatch(setViewMode( "customer-view"))
    }
  }, [userType, partnerCustomer, navigate]);
    // Navigate if userType is 2 or 3 AND partnerCustomer.customerId is missing/null/undefined
    if ((userType === 2 || userType === 3) && !partnerCustomer?.customerId) {
      navigate('/partner-dashboard');
    }

  return (
    <Box sx={{ flexGrow: 1, p: 5 }}>
      <Grid container spacing={1} sx={{ mt: 5, border: 'none', p: 0 }}>
        <Grid item xs={12}>
          <MyWorkflows />
        </Grid>
      </Grid>
    </Box>
  )

};

export default Dashboard;
